import {downloadFileFromLink} from "../../../anwendungskonfigurator/misc/file-download"

export const DruckcenterActions = ({
    getDataFromPointer,
    updateData,
    loadCurrentLocationData,
    getDataFromBackendWithQuery,
}) => {
    return {
        INIT_PRINTCENTER: () => {},
        PRINTCENTER_SEARCH: () => {
            const href = {
                href: window._env_.API_URL_UWP + "/api/printcenter",
                methods: ["GET"],
            }
            const searchType = getDataFromPointer("/druckcenter/suchauswahl")
            const suchtext = getDataFromPointer("/druckcenter/suchtext")

            getDataFromBackendWithQuery(href, "/druckcenter/result", {
                [searchType]: suchtext,
            })
        },
        PRINTCENTER_GET_FILE: (payload) => {
            const href =
                payload?._links?.loadAngebotPdf?.href ?? payload?._links?.document?.href
            return downloadFileFromLink(
                {href, methods: ["GET"]},
                payload?.tarifierungsvariante ?? "Dokument",
            )
        },
    }
}
